import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CustomisableVariables } from '@shared/models/customisable-variables';
import { CustomisableVariablesService } from '@shared/services/customisable-variables.service';
import { ProfileAction } from '@shared/shared/enums/profile-action.enum';
import { ParamsPopupCanNotEdit } from '@shared/shared/interfaces/params-popup-can-not-edit.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export abstract class PopupCanNotEditComponent {
  public customisableVariables$: Observable<CustomisableVariables>;
  public titleKey: string;
  public closeButtonKey: string;
  public text$: Observable<string>;

  constructor(
    data: ParamsPopupCanNotEdit,
    private customisableVariablesService: CustomisableVariablesService,
    private dialogRef: MatDialogRef<PopupCanNotEditComponent>
  ) {
    this.customisableVariables$ = customisableVariablesService.variables;
    this.setTranslations(data);
  }

  public closePopUp() {
    this.dialogRef.close();
  }

  private setTranslations(data: ParamsPopupCanNotEdit) {
    const client = (data.client.charAt(0).toUpperCase() + data.client.slice(1)).replace(/\s/g, '');

    this.titleKey = `${data.content}${client}:${data.action}PopupBoxTitle`;
    this.closeButtonKey = `${data.content}${client}:${data.action}PopupBoxClose`;
    this.text$ = this.customisableVariablesService.variables.pipe(
      map((variables) => {
        const type = this.getCustomVariableType(data.action);
        const location = this.getCustomVariableLocation(data.content);
        const customVariableKey = `prevent_${type}_${location}`;

        return variables[customVariableKey];
      })
    );
  }

  private getCustomVariableType(action: ProfileAction): string {
    const customVariableMap: Record<ProfileAction, string> = {
      [ProfileAction.AddNumber]: 'add_number',
      [ProfileAction.AddAddress]: 'add_address',
      [ProfileAction.EditNonPeferredNumber]: 'edit_nonpreferred_number',
      [ProfileAction.EditNonPeferredAddress]: 'edit_nonpreferred_address',
      [ProfileAction.EditPeferredNumber]: 'edit_preferred_number',
      [ProfileAction.EditPeferredAddress]: 'edit_preferred_address',
      [ProfileAction.ChangePreferredNumber]: 'change_preferred_number',
      [ProfileAction.ChangePreferredAddress]: 'change_preferred_address',
      [ProfileAction.ChangeEmail]: 'change_email',
    };

    return customVariableMap[action] || '';
  }

  private getCustomVariableLocation(content: string): string {
    const mappings = {
      DiningRequestSummary: 'dining_request_summary',
      EntertainmentBookingSummary: 'entertainment_booking_summary',
      ProfileDetails: 'myprofile',
      TravelBookingSummary: 'travel_booking_summary',
    };

    return mappings[content] || '';
  }
}
